import get from 'lodash/get'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      currentStep: 1,
      isLoadingPaymentProduct: false,
      isLoadingPaymentProductAccount: false,
    }
  },
  computed: {
    ...mapState({
      dashboardLoading: (state) => state.dashboard.loading,
    }),
    isSubmitting() {
      return (
        this.dashboardLoading.some((r) =>
          [
            'getPaymentProducts',
            'getPaymentAccounts',
            'updateProfile',
          ].includes(r)
        ) ||
        this.isLoadingPaymentProduct ||
        this.isLoadingPaymentProductAccount
      )
    },
  },
  methods: {
    handleGoBack() {
      if (this.currentStep === 1) {
        this.$emit('go-to-add-payment-method-more-info', this.paymentType)
        return
      }
      this.currentStep -= 1
    },
    getProductUuid(product) {
      return get(product, [
        'entity_payment_vendor_product',
        'entity_payment_vendor_product_uuid',
      ])
    },
    async createPaymentProduct(payload) {
      this.isLoadingPaymentProduct = true
      try {
        const product = await this.$axios.$post(
          '/PROFILE_URL/payments/product',
          payload
        )
        await this.$store.dispatch('dashboard/getPaymentProducts')
        return { data: { product }, error: null }
      } catch (error) {
        return {
          data: null,
          error: this.getError(error),
        }
      } finally {
        this.isLoadingPaymentProduct = false
      }
    },
    async createPaymentProductAccount(payload) {
      try {
        this.isLoadingPaymentProductAccount = true
        const account = await this.$axios.$post(
          '/PROFILE_URL/payments/product/account',
          payload
        )
        await this.$store.dispatch('dashboard/getPaymentAccounts', {
          ...account,
        })
        return { data: { account }, error: null }
      } catch (error) {
        return {
          data: null,
          error: this.getError(error),
        }
      } finally {
        this.isLoadingPaymentProductAccount = false
      }
    },
    getError(error) {
      const stripeError = get(error, ['response', 'data', 'stripe_api_error'])
      const paymentsError = get(error, [
        'response',
        'data',
        'error during POST request, additional details have been logged',
      ])
      const msgError = get(error, ['response', 'data', 'msg'])
      let showErrorScreen = false
      let description

      if (stripeError && stripeError.includes(':')) {
        description = stripeError.split(':').pop()
      } else if (paymentsError) {
        description = this.$t('payments__stripe_error_message')
        showErrorScreen = true
      } else if (msgError) {
        description = this.$t('ppm_modal__default_error_subheading')
        showErrorScreen = true
      }

      this.$analytics.sendEvent('ppm_modal_submitted_error', {
        error: get(error, ['response', 'data']),
        description,
        showErrorScreen,
      })

      return {
        description,
        showErrorScreen,
      }
    },
  },
}
